/**
 *
 * @file
 * @author
 */

import cloneDeep from 'lodash/cloneDeep'
import diff from 'deep-diff'

import {
    VUEX_GLOBAL_ACTION_PROMPT_YES,
    VUEX_GLOBAL_ACTION_PROMPT_NO,
    VUEX_GLOBAL_ACTION_PROMPT_SHOW,
    VUEX_GLOBAL_ACTION_PROMPT_CLOSED,
    VUEX_GLOBAL_ACTION_PROMPT_SET_ACTION_OBJECT,
    VUEX_GLOBAL_ACTION_PROMPT_SET_STATE_CHANGE_WATCHERS
}   from '@/store/constants/global_action_prompt'


var defaultActionObj = {
    title                           :   'YOU HAVE UNSAVED ITEMS',
    description                     :   'Are you sure you want to cancel?',
    dispatchAction                  :   null,
    dispatchActionObject            :   null
}
const state = {
    show: false,

    //pass in these items
    actionObj: cloneDeep(defaultActionObj),
    stateChangeWatchers: [],
    stateChangeWatchersInitial: []
}

const actions = {
    [VUEX_GLOBAL_ACTION_PROMPT_SET_STATE_CHANGE_WATCHERS]: ({ commit, state, dispatch, rootState }, payload) => {

        var obj = {
            data:payload.stateChangeWatchers,
            rootState:rootState
        }
        commit(VUEX_GLOBAL_ACTION_PROMPT_SET_STATE_CHANGE_WATCHERS, obj)
    },
    [VUEX_GLOBAL_ACTION_PROMPT_SHOW]: ({ commit, state, dispatch, rootState }, payload) => {
        commit(VUEX_GLOBAL_ACTION_PROMPT_SET_ACTION_OBJECT, payload.actionObj)

        var showIt = false
        if (payload.actionObj.checkChangedFields) {
            if (state.stateChangeWatchers.length > 0) {
                for (var i = 0; i < state.stateChangeWatchers.length; i++) {
                    var s = state.stateChangeWatchers[i]

                    if (s instanceof Array) {
                        var rs1 = s[0]
                        var rs2 = s[1]
                        s = rootState[rs1][rs2]
                    }

                    var sInit = state.stateChangeWatchersInitial[i]
                    var changes = diff(s, sInit);
                    if (changes) {
                        showIt = true
                    }
                }
            }
        } else {
            //always show it if not checkign for changed fields
            showIt = true
        }

        //if we don't show it, close the dispatch event
        if (showIt) {
            commit(VUEX_GLOBAL_ACTION_PROMPT_SHOW, showIt)
        } else {
            dispatch (VUEX_GLOBAL_ACTION_PROMPT_YES)
        }

    },
    [VUEX_GLOBAL_ACTION_PROMPT_YES]: ({ commit, state, dispatch }) => {
        dispatch(state.actionObj.dispatchAction,state.actionObj.dispatchActionObject);
        commit(VUEX_GLOBAL_ACTION_PROMPT_CLOSED)
        commit(VUEX_GLOBAL_ACTION_PROMPT_SHOW, false)
    },
    [VUEX_GLOBAL_ACTION_PROMPT_NO]: ({ commit, state }) => {
        commit(VUEX_GLOBAL_ACTION_PROMPT_SHOW, false)
    },
}

const mutations = {
    [VUEX_GLOBAL_ACTION_PROMPT_SHOW]: (state, payload) => {
        state.show = payload
    },
    [VUEX_GLOBAL_ACTION_PROMPT_CLOSED]: (state, payload) => {
        state.actionObj = cloneDeep(defaultActionObj)
    },
    [VUEX_GLOBAL_ACTION_PROMPT_SET_ACTION_OBJECT]: (state, payload) => {
        if (payload.title && payload.title != '') {
            state.actionObj.title = payload.title
        } else {
            state.actionObj.title = defaultActionObj.title
        }
        if (payload.description && payload.description != '') {
            state.actionObj.description = payload.description
        } else {
            state.actionObj.description = defaultActionObj.description
        }
        if (payload.dispatchAction && payload.dispatchAction != '') {
            state.actionObj.dispatchAction = payload.dispatchAction
        } else {
            state.actionObj.dispatchAction = defaultActionObj.dispatchAction
        }
        if (payload.dispatchActionObject && payload.dispatchActionObject != '') {
            state.actionObj.dispatchActionObject = payload.dispatchActionObject
        } else {
            state.actionObj.dispatchActionObject = defaultActionObj.dispatchActionObject
        }
        state.actionObj.checkChangedFields = payload.checkChangedFields

    },
    [VUEX_GLOBAL_ACTION_PROMPT_SET_STATE_CHANGE_WATCHERS]: (state, obj) => {
        state.stateChangeWatchersInitial = []
        state.stateChangeWatchers = []
        var rootState = obj.rootState
        var data = obj.data
        if (data && data != '') {
            for (var i=0;i<data.length;i++) {
                var s = data[i]
                if (s instanceof Array) {
                    var rs1 = s[0]
                    var rs2 = s[1]
                    var newS = rootState[rs1][rs2]

                    state.stateChangeWatchers.push(s)
                    var sClone = cloneDeep(newS)
                    state.stateChangeWatchersInitial.push(sClone)

                } else {
                    state.stateChangeWatchers.push(s)
                    var sClone = cloneDeep(s)
                    state.stateChangeWatchersInitial.push(sClone)
                }
            }
        }
    }

}


export default {
    state,
    actions,
    mutations
}
